export enum USER_SETTINGS {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453266
     */
    MY_SETTINGS = 'MY_SETTINGS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453799
     */
    MAIN_LANGUAGE = 'USER_PROFILE_MAIN_LANGUAGE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453796
     */
    ALTERNATIVE_LANGUAGE = 'USER_PROFILE_FALLBACK_LANGUAGE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453797
     */
    HISTORY_VISIBLE = 'USER_PROFILE_HISTORY_VISIBLE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453798
     */
    HISTORY_VISIBLE_HELP = 'USER_PROFILE_HISTORY_VISIBLE_HELP',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453787
     */
    ALTERNATE_EMAIL = 'USER_PROFILE_ALTERNATE_EMAIL',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453788
     */
    CURRENT_PASSWORD = 'USER_PROFILE_CURRENT_PASSWORD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453804
     */
    PASSWORD = 'USER_PROFILE_PASSWORD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453806
     */
    REPASSWORD = 'USER_PROFILE_REPASSWORD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453805
     */
    PASSWORD_DO_NOT_MATCH = 'USER_PROFILE_PASSWORD_DO_NOT_MATCH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077941
     */
    ENABLE_PUSH_LABEL = 'NOTIFICATION.PREFERENCES.ENABLE.PUSH.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077942
     */
    ENABLE_PUSH_DESCRIPTION = 'NOTIFICATION.PREFERENCES.ENABLE.PUSH.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077951
     */
    FREQUENCY = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077955
     */
    FREQUENCY_IMMEDIATE_LABEL = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.IMMEDIATE.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077964
     */
    FREQUENCY_IMMEDIATE_DESCRIPTION = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.IMMEDIATE.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078053
     */
    FREQUENCY_DAILY_SUMMARY_LABEL = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.DAILY_SUMMARY.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078060
     */
    FREQUENCY_DAILY_SUMMARY_DESCRIPTION = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.DAILY_SUMMARY.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=27149299
     */
    SOCIAL_PROFILES = 'SOCIAL_PROFILES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=41841405
     */
    NATIVE_INTEGRATIONS = 'NATIVE_INTEGRATIONS',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078077
     */
    DO_NOT_DISTURB_HEADER = 'NOTIFICATION.PREFERENCES.DO_NOT_DISTURB.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078811
     */
    DO_NOT_DISTURB_LABEL = 'NOTIFICATION.PREFERENCES.DO_NOT_DISTURB.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078820
     */
    NOTIFICATION_PREFERENCES_TABLE_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078850
     */
    BELL_COLUMN_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.BELL.COLUMN.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078855
     */
    EMAIL_COLUMN_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.EMAIL.COLUMN.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078825
     */
    CHECK_ALL_ROW_LABEL = 'NOTIFICATION.PREFERENCES.TABLE.CHECK_ALL.ROW.LABEL',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453808
     */
    USER_PROFILE_SAVE_SUCCESS = 'USER_PROFILE_SAVE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=337316449
     */
    SETTINGS_SUBTITLE = 'USER_SETTINGS.SUBTITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=342804650
     */
    INTEGRATIONS_EMPTY_STATE = 'USER_SETTINGS.INTEGRATIONS_EMPTY_STATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=342804656
     */
    INTEGRATIONS_EMPTY_DESCRIPTION = 'USER_SETTINGS.INTEGRATIONS_EMPTY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434744003
     */
    UNSUBSCRIBE = 'USER_SETTINGS.UNSUBSCRIBE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=55428375
     */
    UNSUBSCRIBE_FROM_EMAIL = 'USER_SETTINGS.UNSUBSCRIBE_FROM_EMAIL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434743766
     */
    UNSUBSCRIBE_MESSAGE_PART1 = 'USER_SETTINGS.UNSUBSCRIBE_MESSAGE_PART1',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434746277
     */
    UNSUBSCRIBE_MESSAGE_PART2 = 'USER_SETTINGS.UNSUBSCRIBE_MESSAGE_PART2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628466639
     */
    APP_LOGIN_CODE = 'USER_SETTINGS.APP_LOGIN_CODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471897
     */
    APP_LOGIN_SCAN_QR_CODE = 'USER_SETTINGS.APP_LOGIN_SCAN_QR_CODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471959
     */
    APP_LOGIN_GENERATE_QR_CODE = 'USER_SETTINGS.APP_LOGIN_GENERATE_QR_CODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471981
     */
    QR_CODE_WARNING = 'USER_SETTINGS.QR_CODE_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471998
     */
    QR_CODE_EXPIRES = 'USER_SETTINGS.QR_CODE_EXPIRES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628565610
     */
    QR_CODE = 'USER_SETTINGS.QR_CODE',
}

export const getNotificationLabelByKind = (kind: string) => `NOTIFICATION.TYPE.${kind.replace(/_/g, '.')}.DESCRIPTION`;
